import React, { useState, useEffect } from 'react';
import { Column, Notification, Delete } from "rbx";
import Layout from "../../layout";
import Controls from '../../../components/pdv/Controls';
import MenuItems from '../../../components/components/MenuItems';

const PdvIndexScreen = () => {
  const [message, setMessage] = useState('');
  const [itemSelected, setItemSelected] = useState(null);

  const goToMenu = () => {
    setItemSelected(null);
  }

  const links = [
    { item: <Controls.PdvActivateForm setMessage={setMessage} goToMenu={goToMenu} />, description: "Ativar PDV" },
    { item: <Controls.SetAdmForm setMessage={setMessage} goToMenu={goToMenu} userPdv={true} />, description: "Definir PDV como Administrador" },
    { item: <Controls.PdvEditForm setMessage={setMessage} goToMenu={goToMenu} />, description: "Editar dados do PDV - Revendedor"},
    { item: <Controls.AddCadForm setMessage={setMessage} goToMenu={goToMenu} userPdv={true} />, description: "Inserir CADs"},
    //{ url: "/pdv/remove-cads", description: "Estornar CADs" },
    { item: <Controls.PdvParkingHistoryList goToMenu={goToMenu} />, description: "Histórico de uso" },
    { item: <Controls.PdvTransactionsHistoryList goToMenu={goToMenu} />, description: "Histórico de Transações"},
    { item: <Controls.PdvVehiclesParkedList goToMenu={goToMenu} />, description: "Veículos Estacionados" },
  ]

  const linksExtras = [
    { url: "/pdv/find", description: "Localizar outro PDV"},
    { url: "/pdv/new", description: "Registrar novo PDV"},
  ]

  useEffect(() => {
    if (message!=='')
      setTimeout(() => setMessage(''), 5000);
  }, [message]);

  return (
    <Layout controllerName='PDV' breadcrumb='Dashbord / PDV'>
      <Column.Group centered>
        <Column size={4}>
          <Controls.PdvDetail />
        </Column>
        <Column>
          { message!=='' && <Notification color={message[0]}><Delete onClick={()=>setMessage('')} /> {message[1]}</Notification> }
          {
            itemSelected ?
              itemSelected :
                <MenuItems setItemSelected={setItemSelected} links={links} linksExtras={linksExtras} />
          }
        </Column>
      </Column.Group>
    </Layout>
  )

}

export default PdvIndexScreen;

